'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.betagroups.list', [])
  .controller('BetaGroupsListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/betagroups/list/index.js